import { SIGNUP_FORM_URL } from "../external-links";

function HealthVaultDiagram() {
  return (
    <div className="vault-diagram">
      <svg
        className="vault-diagram-svg"
        viewBox="0 0 420 420"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="vaultGrad" cx="42%" cy="42%" r="58%">
            <stop offset="0%" stopColor="#D4F0E0" />
            <stop offset="60%" stopColor="#78D8A8" />
            <stop offset="100%" stopColor="#36B880" />
          </radialGradient>
          <radialGradient id="glowCenter" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="rgba(54,184,128,0.15)" />
            <stop offset="100%" stopColor="rgba(54,184,128,0)" />
          </radialGradient>
          <filter id="softBlob" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
          </filter>
          <filter id="outerGlow" x="-40%" y="-40%" width="180%" height="180%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="18" />
          </filter>
        </defs>

        {/* Ambient outer glow */}
        <ellipse cx="210" cy="210" rx="175" ry="168" fill="url(#glowCenter)" />

        {/* Large background organic wash */}
        <path
          d="M185 52 C248 32, 358 68, 372 158 C386 248, 342 355, 252 368 C162 381, 55 328, 48 238 C41 148, 122 72, 185 52Z"
          fill="rgba(215,242,228,0.15)"
          filter="url(#softBlob)"
        />

        {/* Left organic blob — soft peach */}
        <path
          d="M88 148 C112 132, 145 148, 142 182 C139 216, 112 238, 88 232 C64 226, 48 202, 55 178 C60 158, 70 155, 88 148Z"
          fill="rgba(248,208,185,0.22)"
          filter="url(#softBlob)"
        />

        {/* Top-right blob — sage */}
        <path
          d="M305 72 C338 56, 372 82, 368 118 C364 154, 335 172, 308 162 C281 152, 268 118, 278 92 C285 72, 292 75, 305 72Z"
          fill="rgba(215,244,230,0.25)"
          filter="url(#softBlob)"
        />

        {/* Bottom-left blob — light peach */}
        <path
          d="M108 278 C142 258, 180 272, 178 310 C176 348, 148 370, 118 368 C88 366, 65 342, 68 312 C71 282, 82 282, 108 278Z"
          fill="rgba(248,215,192,0.22)"
          filter="url(#softBlob)"
        />

        {/* Right-bottom blob — sage */}
        <path
          d="M328 232 C358 218, 385 238, 380 265 C375 292, 350 310, 325 305 C300 300, 288 272, 298 248 C305 230, 315 235, 328 232Z"
          fill="rgba(220,245,232,0.22)"
          filter="url(#softBlob)"
        />

        {/* Small accent top — warm peach */}
        <path
          d="M245 58 C265 46, 288 60, 285 82 C282 104, 262 115, 248 108 C234 101, 225 82, 232 66 C236 55, 238 58, 245 58Z"
          fill="rgba(248,212,190,0.18)"
          filter="url(#softBlob)"
        />

        {/* Small accent bottom-center */}
        <path
          d="M168 338 C190 328, 215 340, 212 360 C209 380, 190 392, 172 388 C154 384, 145 368, 150 352 C154 338, 158 340, 168 338Z"
          fill="rgba(225,245,235,0.18)"
          filter="url(#softBlob)"
        />

        {/* Central Health Vault blob */}
        <path
          d="M205 128 C238 110, 282 125, 292 168 C302 211, 288 262, 252 278 C216 294, 165 282, 148 245 C131 208, 142 162, 172 142 C185 133, 195 130, 205 128Z"
          fill="url(#vaultGrad)"
        />

        {/* Inner highlight on central blob */}
        <path
          d="M198 145 C222 132, 258 142, 265 172 C272 202, 260 240, 238 250 C216 260, 178 250, 168 225 C158 200, 168 168, 188 152 C192 148, 194 146, 198 145Z"
          fill="rgba(255,255,255,0.18)"
        />

        {/* Health Vault text */}
        <text
          x="215"
          y="196"
          textAnchor="middle"
          fill="white"
          fontFamily="'Outfit', system-ui, sans-serif"
          fontSize="15"
          fontWeight="600"
          letterSpacing="0.02em"
        >
          Health
        </text>
        <text
          x="215"
          y="216"
          textAnchor="middle"
          fill="white"
          fontFamily="'Outfit', system-ui, sans-serif"
          fontSize="15"
          fontWeight="600"
          letterSpacing="0.02em"
        >
          Vault
        </text>

        {/* Guide pill — top right */}
        <g>
          <rect x="328" y="128" width="58" height="26" rx="13" fill="rgba(255,255,255,0.78)" />
          <text x="357" y="145" textAnchor="middle" fill="#6B6460" fontFamily="'Outfit', system-ui, sans-serif" fontSize="11" fontWeight="500">Guide</text>
        </g>

        {/* Guide pill — right */}
        <g>
          <rect x="344" y="215" width="58" height="26" rx="13" fill="rgba(255,255,255,0.78)" />
          <text x="373" y="232" textAnchor="middle" fill="#6B6460" fontFamily="'Outfit', system-ui, sans-serif" fontSize="11" fontWeight="500">Guide</text>
        </g>

        {/* Guide pill — bottom right */}
        <g>
          <rect x="314" y="298" width="58" height="26" rx="13" fill="rgba(255,255,255,0.78)" />
          <text x="343" y="315" textAnchor="middle" fill="#6B6460" fontFamily="'Outfit', system-ui, sans-serif" fontSize="11" fontWeight="500">Guide</text>
        </g>
      </svg>
    </div>
  );
}

const PILLARS = [
  {
    word: "Own.",
    color: "#36B880",
    label: "HEALTH VAULT",
    desc: "All your health sources in one encrypted, portable vault you control.",
  },
  {
    word: "Understand.",
    color: "#E8A878",
    label: "AI GUIDES",
    desc: "Expert health AI analyzes your longitudinal data for personalized insights.",
  },
  {
    word: "Share.",
    color: "#E0607A",
    label: "ON YOUR TERMS",
    desc: "Send specific results to doctors or family. Revoke access anytime.",
  },
];

const PROTOCOLS = [
  {
    name: "Blueprint Protocol v4",
    author: "Bryan Johnson",
    desc: "Optimize for longevity and biological age reduction.",
  },
  {
    name: "Sleep & Recovery Stack",
    author: "Biohacker Dave",
    desc: "Community-favorite for deep rest and performance.",
  },
  {
    name: "Metabolic Health Guide",
    author: "Dr. Mark Hyman",
    desc: "Optimize fuel usage and energy levels.",
  },
  {
    name: "Gut Microbiome Balance",
    author: "Dr. Will Bulsiewicz",
    desc: "Improve digestion and immune health.",
  },
];

export function LandingPage() {
  return (
    <>
      {/* ===== HERO ===== */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-title-accent">Kin.</span> Your Health,
            <br />
            Intelligent.
          </h1>
          <p className="hero-subtitle">
            Get expert health insights on your own personal data — without
            giving up your privacy. Your vault, your rules.
          </p>
          <div className="hero-actions">
            <a href={SIGNUP_FORM_URL} target="_blank" rel="noopener noreferrer" className="hero-cta-outlined">
              Create an Account
            </a>
          </div>
        </div>
        <HealthVaultDiagram />
      </section>

      {/* ===== PILLARS ===== */}
      <section className="pillars-section">
        <div className="pillars-grid">
          {PILLARS.map((p) => (
            <div key={p.word} className="pillar">
              <span className="pillar-word" style={{ color: p.color }}>
                {p.word}
              </span>
              <span className="pillar-bar" style={{ background: p.color }} />
              <span className="pillar-label">{p.label}</span>
              <p className="pillar-desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== RECOMMENDED PROTOCOLS ===== */}
      <section className="protocols-section">
        <div className="section-header">
          <h2 className="section-heading">Recommended Guides</h2>
        </div>
        <div className="protocols-grid">
          {PROTOCOLS.map((p) => (
            <div key={p.name} className="protocol-card">
              <div className="protocol-card-header">
                <div className="protocol-card-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                  </svg>
                </div>
                <div>
                  <h3 className="protocol-card-name">{p.name}</h3>
                  <span className="protocol-card-author">{p.author}</span>
                </div>
              </div>
              <p className="protocol-card-desc">{p.desc}</p>
              <a href={SIGNUP_FORM_URL} target="_blank" rel="noopener noreferrer" className="protocol-install-btn">Install</a>
            </div>
          ))}
        </div>
      </section>

      {/* ===== BOTTOM CTA ===== */}
      <section className="bottom-cta">
        <h2 className="bottom-cta-heading">
          Start your journey to intelligent health.
        </h2>
        <a href={SIGNUP_FORM_URL} target="_blank" rel="noopener noreferrer" className="hero-cta-outlined">
          Create an Account
        </a>
      </section>
    </>
  );
}
